<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
        <div class="containar22">
          <div class="content-title">
            <h2>
              肉球コメント v2
            </h2>
            <p>色をカスタマイズできます。</p>
            <p>作成したコードをOBSのカスタムCSSに追記してください。</p>
          </div>
          <div class="contents-block">
            <div class="nyan2_line__left">
                <span class="nyan2_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="nyan2_line__left-text">
                    <span class="nyan2_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center', 'width': '0.8rem', 'height': '0.8rem', 'top':'35%' }"></span>
                    <div class="nyan2_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor,'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '50px 40px', 'background-position': 'calc(100% - 1px) calc(100% + 13px)'  }">Hello🐟</div>
                </div>
                <span class="nyan2_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="nyan2_line__left-text">
                    <span class="nyan2_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center', 'width': '0.8rem', 'height': '0.8rem', 'top':'35%'  }"></span>
                    <span class="nyan2_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor, 'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '50px 40px', 'background-position': 'calc(100% - 1px) calc(100% + 13px)' }">いい天気ですね</span>
                </div>
            </div>
            <div class="set">
              <h3>カラー選択</h3>
              <div class="color-picker-grid">
                <div class="color-picker-column">
                  <h4>背景カラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="backgroundColorObj" @input="updateBackgroundColor"></chrome-picker>
                  </div>
                </div>
                <div class="color-picker-column">
                  <h4>メインカラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="mainColorObj" @input="updateMainColor"></chrome-picker>
                  </div>
                </div>
                <div class="color-picker-column">
                  <h4>名前背景カラー</h4>
                  <div class="color-picker-wrapper">
                    <chrome-picker :value="nameBgColorObj" @input="updateNameBgColor"></chrome-picker>
                  </div>
                </div>
              </div>
              
              <h3>コピペ用CSS</h3>
              <div class="url-description">
                <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
              </div>
              <h4>YouTubeLIVEコメント欄のカスタムCSS</h4>
              <div class="url-container">
                <textarea id="target" readonly class="url-input textarea" v-model="YTgeneratedCSS" />
                <button @click="copy" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>
              <h4>Twitchコメント欄のカスタムCSS</h4>
              <div class="url-container">
                <textarea id="target" readonly class="url-input textarea" v-model="TWgeneratedCSS" />
                <button @click="copy2" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
import {Chrome} from 'vue-color'
export default {
    components: {
        secondHeader,
        sidebar,
        'chrome-picker': Chrome,
    },
  data() {
    return {
      backgroundColor: '#C9D6DF',
      mainColor: '#52616B',
      nameBgColor: '#F0F5F9',
      backgroundColorObj: {
        hex: '#C9D6DF',
        hsl: { h: 200, s: 31, l: 83, a: 1 },
        rgba: { r: 201, g: 214, b: 223, a: 1 },
        a: 1
      },
      mainColorObj: {
        hex: '#52616B',
        hsl: { h: 200, s: 13, l: 37, a: 1 },
        rgba: { r: 82, g: 97, b: 107, a: 1 },
        a: 1
      },
      nameBgColorObj: {
        hex: '#F0F5F9',
        hsl: { h: 200, s: 50, l: 97, a: 1 },
        rgba: { r: 240, g: 245, b: 249, a: 1 },
        a: 1
      },
      YTgeneratedCSS: '',
      TWgeneratedCSS: '',
    };
  },
  computed: {
    svgBackground() {
      const svgPath= `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 256.00 256.00'><circle fill='${this.mainColor}' opacity='0.5' cx='92.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='163.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='48.00' cy='114.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='208.00' cy='114.00' r='24.97'/><path fill='${this.mainColor}' opacity='0.5' d=' M 77.43 197.36 C 62.32 191.25 56.22 177.68 60.96 162.41 C 68.22 139.04 85.51 118.09 106.17 105.34 C 118.03 98.02 127.20 93.77 140.32 99.20 C 160.08 107.38 175.68 122.80 187.35 140.15 C 194.38 150.59 200.84 166.33 197.83 178.58 C 195.30 188.88 188.12 194.62 178.39 198.06 C 174.68 199.36 170.82 201.01 167.27 202.00 C 151.62 206.36 135.41 207.62 119.25 206.73 Q 97.67 205.54 77.43 197.36 Z'/></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath)}")`;
    },
    svgBackground2() {
      const svgPath2= `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 256.00 256.00'><circle fill='${this.mainColor}' cx='92.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' cx='163.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' cx='48.00' cy='114.00' r='24.97'/><circle fill='${this.mainColor}' cx='208.00' cy='114.00' r='24.97'/><path fill='${this.mainColor}' d=' M 77.43 197.36 C 62.32 191.25 56.22 177.68 60.96 162.41 C 68.22 139.04 85.51 118.09 106.17 105.34 C 118.03 98.02 127.20 93.77 140.32 99.20 C 160.08 107.38 175.68 122.80 187.35 140.15 C 194.38 150.59 200.84 166.33 197.83 178.58 C 195.30 188.88 188.12 194.62 178.39 198.06 C 174.68 199.36 170.82 201.01 167.27 202.00 C 151.62 206.36 135.41 207.62 119.25 206.73 Q 97.67 205.54 77.43 197.36 Z'/></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath2)}")`;
    },
  },
  mounted() {
    this.generateCSS();
  },
  methods: {
    generateCSS() {
      const svgPath= `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 256.00 256.00'><circle fill='${this.mainColor}' opacity='0.5' cx='92.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='163.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='48.00' cy='114.00' r='24.97'/><circle fill='${this.mainColor}' opacity='0.5' cx='208.00' cy='114.00' r='24.97'/><path fill='${this.mainColor}' opacity='0.5' d=' M 77.43 197.36 C 62.32 191.25 56.22 177.68 60.96 162.41 C 68.22 139.04 85.51 118.09 106.17 105.34 C 118.03 98.02 127.20 93.77 140.32 99.20 C 160.08 107.38 175.68 122.80 187.35 140.15 C 194.38 150.59 200.84 166.33 197.83 178.58 C 195.30 188.88 188.12 194.62 178.39 198.06 C 174.68 199.36 170.82 201.01 167.27 202.00 C 151.62 206.36 135.41 207.62 119.25 206.73 Q 97.67 205.54 77.43 197.36 Z'/></svg>`;
      const svgPath2= `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 256.00 256.00'><circle fill='${this.mainColor}' cx='92.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' cx='163.00' cy='67.00' r='24.97'/><circle fill='${this.mainColor}' cx='48.00' cy='114.00' r='24.97'/><circle fill='${this.mainColor}' cx='208.00' cy='114.00' r='24.97'/><path fill='${this.mainColor}' d=' M 77.43 197.36 C 62.32 191.25 56.22 177.68 60.96 162.41 C 68.22 139.04 85.51 118.09 106.17 105.34 C 118.03 98.02 127.20 93.77 140.32 99.20 C 160.08 107.38 175.68 122.80 187.35 140.15 C 194.38 150.59 200.84 166.33 197.83 178.58 C 195.30 188.88 188.12 194.62 178.39 198.06 C 174.68 199.36 170.82 201.01 167.27 202.00 C 151.62 206.36 135.41 207.62 119.25 206.73 Q 97.67 205.54 77.43 197.36 Z'/></svg>`;
      const svgEncoded1 = encodeURIComponent(svgPath);
      const svgEncoded2 = encodeURIComponent(svgPath2);
      this.YTgeneratedCSS = `yt-live-chat-author-chip #author-name{
        color: ${this.mainColor}!important;
        background-color: ${this.nameBgColor}!important;
    }
    yt-live-chat-text-message-renderer #message {
        background-color: ${this.backgroundColor};
        border: 2px solid ${this.mainColor} !important;
        color: ${this.mainColor} !important;
        background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    yt-live-chat-text-message-renderer #message::before{
        background-image: url("data:image/svg+xml,${svgEncoded2}");
    }
      `;
    this.TWgeneratedCSS = `.chat-author__display-name{
    color: ${this.mainColor}!important;
    background-color: ${this.nameBgColor}!important;
    }
    [data-a-target="chat-line-message-body"]{
    background-color: ${this.backgroundColor};
    border: 2px solid ${this.mainColor} !important;
    color: ${this.mainColor} !important;
    background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    [data-a-target="chat-line-message-body"]::before{
    background-image: url("data:image/svg+xml,${svgEncoded2}");
    }`;
    },
    async copy() {
      await navigator.clipboard.writeText(this.YTgeneratedCSS);
    },
    async copy2() {
      await navigator.clipboard.writeText(this.TWgeneratedCSS);
    },
    updateBackgroundColor(color) {
      this.backgroundColorObj = color;
      this.backgroundColor = color.hex;
    },
    updateMainColor(color) {
      this.mainColorObj = color;
      this.mainColor = color.hex;
    },
    updateNameBgColor(color) {
      this.nameBgColorObj = color;
      this.nameBgColor = color.hex;
    },
  },
  watch: {
    backgroundColor() {
      this.generateCSS();
    },
    mainColor() {
      this.generateCSS();
    },
    nameBgColor() {
      this.generateCSS();
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kiwi+Maru&family=Single+Day&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar22{
  margin: 0 auto;
  width:100%;
  max-width: 1200px;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0; /* Changed from width: 100% */
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 60px 24px; /* Adjusted padding */
}

/* 古いスタイルを削除してコードを整理 */
  /* コメントプレビュー */
  .nyan2_line__left {
    flex: none;
    width: 420px;
    min-width: 320px;
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

    .nyan2_line__left-text{
        position: relative;
        width: fit-content;
        min-width: 180px!important;
        max-width: 420px!important;
        padding: 2px!important;
        transform-origin: 0% 0%;
        animation: slideIn 0.5s forwards ease-out;
        margin-top:12px;

        font-family: "Kiwi Maru", serif;
        line-height: 1.8;
        letter-spacing: 0.12em;
    }

    .nyan2_text {
        position: relative;
        font-weight: bold;
        border-width: 2px;
        border-style: solid;
        border-radius: 10px;
        padding: 12px 24px 12px 24px;
        margin:-5px;
        margin-bottom:0;
        display: block;
        line-height: 1!important;
    }

    .nyan2_icon {
        position: absolute;
        z-index:2;
        left: 6px;
    }

  .nyan2_line__name{
       position: relative;
       z-index: 2;
       top:12px;
        font-size: 10px !important;
        font-weight: bold;
        padding: 0px 8px 0 8px;
        border: 0.3em solid;
        border-radius: 100vh!important;
  }

/* Layout Styles */
.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  min-width: 0;
}

/* タブレット対応 */
@media screen and (max-width: 1324px) {
  .contents-block {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
  
  .nyan2_line__left {
    width: 100%;
    max-width: 500px;
    margin: 0;
  }
  
  .set {
    width: 100%;
    max-width: 700px;
    margin: 0;
  }
}

/* サイドバーを考慮した中サイズスクリーン対応 */
@media screen and (max-width: 1048px) {
  .content {
    padding: 40px 16px;
  }

}

/* モバイル対応 */
@media screen and (max-width: 767px) {
  .content {
    padding: 24px 16px;
  }
  
  .content-title {
    margin-top: 24px;
    margin-bottom: 32px;
    padding-bottom: 8px;
  }
  
  .content-title h2 {
    font-size: 1.5rem;
    letter-spacing: 1px;
  }
  
  .content-title p {
    font-size: 13px;
    margin: 8px 0 4px 0;
  }
  
  .contents-block {
    display: block;
    margin: 0 auto;
  }

  .nyan2_line__left {
    width: 100%;
    max-width: none;
    min-width: 280px;
    margin: 0 0 24px 0;
    padding: 16px;
  }
  
  .set {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 16px;
  }
  
  .url-input.textarea {
    height: 60px;
  }
  

}

/* 小さなモバイル対応 */
@media screen and (max-width: 480px) {
  .content {
    padding: 16px 1% 16px 1%;
  }
  
  .main {
    flex-direction: column;
  }
  
  .content-title h2 {
    font-size: 1.25rem;
  }
  
  .nyan2_line__left {
    min-width: 260px;
    padding: 12px;
  }
  
  .set {
    padding: 12px;
  }
  
  .color-picker-grid {
    gap: 16px;
  }
  
  .color-picker-wrapper {
    max-width: 220px;
    margin: 0 auto;
  }
  
  .url-container {
    flex-direction: column;
    gap: 12px;
  }
  
  .url-copy-btn {
    width: 100%;
    height: 40px;
  }
}

.set{
  flex: none;
  width: 100%;
  max-width: 740px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-left: 12px;
}



/* Color Picker Grid Layout */
.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  gap: 20px;
  margin-top: 12px;
  justify-content: center;
}

.color-picker-column {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-picker-column h4 {
  font-size: 12px;
  margin: 0 0 12px 0;
  color: #4a5568;
  font-weight: 600;
  text-align: center;
  width: 100%;
}

.color-picker-wrapper {
  width: 225px; /* Fixed width */
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}



/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 76px;
  width: 100%;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}


</style>